import { CheckCircle, Clock, BarChart3, Globe } from 'lucide-react';
import './Hero.css';
import { useEffect } from "react";
const Hero = () => {
  useEffect(() => {
    const words = document.querySelectorAll(".ah-words-wrapper b");
    let index = 0;

    setInterval(() => {
      words[index].classList.remove("is-visible");
      words[index].classList.add("is-hidden");

      index = (index + 1) % words.length;

      words[index].classList.remove("is-hidden");
      words[index].classList.add("is-visible");
    }, 2000);
  }, []);

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title-top">Trade With Low Brokerage & 500X Margin</h1>
          <h1 className="hero-title-main ah-headline clip is-full-width">
            <span className="ah-words-wrapper">
              <b className="is-visible">Indian Stocks (F&O)</b>
              <b className="is-hidden">Indian Commodities</b>
              <b className="is-hidden">COMEX</b>
              <b className="is-hidden">US Stocks</b>
            </span>
          </h1>


          <p className="hero-subtitle">Trade Smart With tredixo.store</p>

          <div className="hero-buttons">
            <button className="btn-primary-outline">Why tredixo.store?</button>
            <button className="btn-primary-solid" onClick={() => window.open('https://web.theplatformapi.com/create-company-user?companyName=TREDIXO&isDemo=false&parentId=6', '_blank')}>Get Started</button>
          </div>

          <div className="brokerage-saved">
            <h2 className="brokerage-amount">₹119.30 Crore</h2>
            <div className="brokerage-info">
              <span className="brokerage-label">BROKERAGE SAVED</span>
              <div className="brokerage-actions">
                <button className="btn-know-more">Know More</button>
                <button className="btn-trade-now">Trade Now</button>
              </div>
            </div>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <CheckCircle className="feature-icon" size={48} />
            <h3 className="feature-title">low Brokerage</h3>
          </div>
          <div className="feature-card">
            <Clock className="feature-icon" size={48} />
            <h3 className="feature-title">24/7 Deposit And Withdrawal</h3>
          </div>
          <div className="feature-card">
            <BarChart3 className="feature-icon" size={48} />
            <h3 className="feature-title">Upto 500x Margin</h3>
          </div>
          <div className="feature-card">
            <Globe className="feature-icon" size={48} />
            <h3 className="feature-title">Indian + US Stocks & Commodities</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
